import React from 'react';
import { Link } from 'react-router-dom';

function Partners() {
  return (
    <>
      <section className="page-hero">
        <h1>Partners</h1>
        <p>Collaborate with AGRO-INVEST to transform agricultural financing.</p>
      </section>

      <div className="page-content">
        <div className="page-image">
          <img src="https://images.unsplash.com/photo-1473968512647-3e447244af8f?w=800&q=80" alt="Partnership in agriculture" />
        </div>
        <h2>Partner With Us</h2>
        <p>AGRO-INVEST works with agricultural suppliers, investors, development organizations, and technology partners to strengthen the agricultural financing ecosystem.</p>

        <h2>Partnership Opportunities</h2>
        <ul>
          <li><strong>Suppliers:</strong> Join our verified supplier network and reach financed farmers</li>
          <li><strong>Investors:</strong> Fund farm opportunities with transparent risk ratings</li>
          <li><strong>Development Organizations:</strong> Integrate our platform into agricultural programs</li>
          <li><strong>Technology Partners:</strong> Satellite, insurance, and USSD integrations</li>
        </ul>

        <h2>Get in Touch</h2>
        <p>Interested in partnering? Contact us to discuss partnership opportunities and how we can work together.</p>

        <p><Link to="/contact" className="btn btn-primary">Contact Partner Team</Link></p>
      </div>
    </>
  );
}

export default Partners;
